import { render, staticRenderFns } from "./Select-dis.vue?vue&type=template&id=0c1eb8cf&scoped=true"
import script from "./Select-dis.js?vue&type=script&lang=js&external"
export * from "./Select-dis.js?vue&type=script&lang=js&external"
import style0 from "./Select-dis.vue?vue&type=style&index=0&id=0c1eb8cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1eb8cf",
  null
  
)

export default component.exports